
import React from 'react';
import { Button } from '@/components/ui/button';
import { ArrowLeft } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

export const PublishHistoryHeader: React.FC = () => {
  const navigate = useNavigate();
  
  return (
    <div className="flex items-center justify-between mb-6">
      <h1 className="text-2xl font-bold">Publiseringshistorikk</h1>
      <Button 
        variant="outline" 
        onClick={() => navigate(-1)}
        className="flex items-center"
      >
        <ArrowLeft className="h-4 w-4 mr-2" />
        Tilbake
      </Button>
    </div>
  );
};
